<template>
  <div id="advCartMainContainer">
    <adv-cart-product-list
      :mini-cart="miniCart"
      :read-only="readOnly"
      :disable-product-links="disableProductLinks"></adv-cart-product-list>
    <adv-cart-gift-list :mini-cart="miniCart"></adv-cart-gift-list>
  </div>
</template>

<script>
import AdvCartProductList from './AdvCartProductList'
import AdvCartGiftList from './AdvCartGiftList'

export default {
  name: 'AdvCart',
  components: {
    AdvCartProductList,
    AdvCartGiftList
  },
  props: {
    miniCart: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    disableProductLinks: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      version: '0.0.1'
    }
  }
}
</script>
